import { Breadcrumb } from "@refinedev/mui";
import { Box } from "@mui/material";
import PageHeading from "../../components/pageHeading";
export const SMCMemberParticipationInIntroductoryCall = () => {
  return (
    <Box>
      <Breadcrumb />
      <PageHeading heading="SMC member participation in introductory call" />
    </Box>
  );
};
